"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.container = typestyle_1.style({
  textAlign: "left"
});

exports.primary = function (background, font) {
  return typestyle_1.style({
    background: background
  }, {
    color: "white"
  }, {
    border: "none"
  }, {
    marginTop: "8px"
  }, {
    borderRadius: "4px"
  }, {
    textTransform: "uppercase"
  }, {
    fontFamily: font
  }, {
    letterSpacing: "1px"
  });
};